import { ReactNode } from 'react';

import { tokens, Typography, Stack } from '@cast/design-system';

type ClusterDetailsDrawerRowProps = {
  label: string;
  children: ReactNode;
  alignTop?: boolean;
};

export const ClusterDetailsDrawerRow = ({
  label,
  children,
  alignTop,
}: ClusterDetailsDrawerRowProps) => (
  <Stack
    direction="row"
    alignItems={alignTop ? 'flex-start' : 'center'}
    gap={16}
    width="100%"
  >
    <Typography
      variant="L12R"
      sx={{
        flex: 1,
        minWidth: 0,
        color: tokens.theme.fg.structural.secondary,
      }}
    >
      {label}
    </Typography>
    {children}
  </Stack>
);
